<script setup lang="ts">
const t2 = useT2({
  'Why?': 'Kodėl?',
})
</script>

<template>
  <div :class="$style.w" class="_w70ch _italic _pt08 _pr1"
    ><IconInfo class="_svg12 _mr04 _relative _c1" :class="$style.i" /><b class="_mr04 _fw-xl _c1">{{ t2('Why?') }}</b
    ><slot
  /></div>
</template>

<style module>
.w span {
  display: inline;
}
.i {
  top: 2px;
}
</style>
